import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import LanguageSwitcher from '../../../components/SignUp/LanguageSwitcher';
import Logo from '../../../components/Common/Logo';
import { useAppSelector } from '../../../redux/hooks';
import { brandLogoKey } from '../../../config/constants';

export default function MiniWebSiteHeader() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const brandLogo = localStorage.getItem(brandLogoKey);
  const { getPublicDetailsLoading } = useAppSelector((state) => state.miniweb);

  return (
    <Grid
      display="flex"
      justifyContent="flex-start"
      position="absolute"
      top={10}
      px={2}
      width={isMobile ? '100%' : '85%'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Logo size={isMobile ? 28 : 32} isMiniWeb />
          {!getPublicDetailsLoading && !brandLogo ? (
            <Typography variant={isMobile ? 'bodyBold' : 'h6'} color="primary">
              Progress Magic
            </Typography>
          ) : null}
        </Box>
        <LanguageSwitcher />
      </Box>
    </Grid>
  );
}
